export const BOARD_SIZE:number = 7;

export const WORD_LIST_LENGTH = 6;

export const GAME_LENGTH_SECONDS = 180;